import * as React from 'react';
import { SVGProps } from 'react';

interface SVGRProps {
	title?: string;
	titleId?: string;
	desc?: string;
	descId?: string;
}

const ArrowDownLong = ({
	title,
	titleId,
	desc,
	descId,
	...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={17}
		height={17}
		fill="none"
		aria-labelledby={titleId}
		aria-describedby={descId}
		{...props}
	>
		{desc ? <desc id={descId}>{desc}</desc> : null}
		{title ? <title id={titleId}>{title}</title> : null}
		<path
			d="M8.14645 16.3536C8.34171 16.5488 8.65829 16.5488 8.85355 16.3536L12.0355 13.1716C12.2308 12.9763 12.2308 12.6597 12.0355 12.4645C11.8403 12.2692 11.5237 12.2692 11.3284 12.4645L8.5 15.2929L5.67157 12.4645C5.47631 12.2692 5.15973 12.2692 4.96447 12.4645C4.7692 12.6597 4.7692 12.9763 4.96447 13.1716L8.14645 16.3536ZM8 0L8 16L9 16L9 0L8 0Z"
			fill={props.fill ? props.fill : 'white'}
		/>
	</svg>
);

export default ArrowDownLong;
